import { Theme } from "@components/theme/Theme";

import { Component } from "./Card";
import {
  StyledImage,
  StyledEyebrow,
  StyledPlayIcon,
  StyledText,
  StyledTimestamp,
} from "./components";
import { CardProps } from "./types";

import styles from "./styles.module.css";

export function WithBlueEyebrow(props: CardProps) {
  const { playIcon, eyebrow, image, timestamp } = props;

  return (
    <article className={styles.cardContainer}>
      <div className={styles.leftColumn} data-skeleton-selector>
        {image && <StyledImage {...props} />}
        {playIcon && <StyledPlayIcon />}
      </div>
      <div className={styles.rightColumn} data-skeleton-selector>
        <Theme accentColor="blue">
          {eyebrow && <StyledEyebrow {...props} />}
        </Theme>
        <StyledText {...props} />
        {timestamp && <StyledTimestamp {...props} />}
      </div>
    </article>
  );
}

export function WithFullBorderStyle(props: CardProps) {
  return (
    <Theme borderStyle="full" radius="small">
      <Component {...props} />
    </Theme>
  );
}

export function WithBlueEyebrowAndFullBorderStyle(props: CardProps) {
  const { playIcon, eyebrow, image, timestamp } = props;

  return (
    <Theme borderStyle="full" radius="small">
      <article className={styles.cardContainer}>
        <div className={styles.leftColumn} data-skeleton-selector>
          {image && <StyledImage {...props} />}
          {playIcon && <StyledPlayIcon />}
        </div>
        <div className={styles.rightColumn} data-skeleton-selector>
          <Theme accentColor="blue" borderStyle="none">
            {eyebrow && <StyledEyebrow {...props} />}
          </Theme>
          <StyledText {...props} />
          {timestamp && <StyledTimestamp {...props} />}
        </div>
      </article>
    </Theme>
  );
}
